import { Injectable, signal } from '@angular/core';

/** Último portfólio/subportfólio selecionado — atalhos da command palette. */
@Injectable({ providedIn: 'root' })
export class CompositionNavContextService {
  readonly lastPortfolioId = signal<string | null>(null);
  readonly lastSubportfolioId = signal<string | null>(null);

  setLastPortfolio(id: string): void {
    this.lastPortfolioId.set(id);
  }

  setLastSubportfolio(id: string): void {
    this.lastSubportfolioId.set(id);
  }
}
